let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eBvt5")).then(() => parcelRequire('kq7mF'));